import styles from "./ProductCard.module.css";

export default function ProductCard({ product, onClick }) {
  return (
    <div
      className={styles.card}
      onClick={onClick}
    >
      <h2 className="font-bold">{product.name}</h2>
    </div>
  );
}
